import React, { Component } from 'react';
import styles from "../styles/home.module.scss";
import { Project1, Project2, Project3 } from "../assets/index";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

class Projects extends Component {
    state = { 
        title:"Projects",
        primaryTitle:"See What ⚡️ Swifty Config can do"
     } 
    styles={
        textAlign:"center",
        marginTop:"2rem",
        fontSize:"3rem",
    }
    render() { 
        return (
            <div className={styles["project-container"]}>
                <h1 style={this.styles}>{this.state.title}</h1>
                <div style={
                    {
                        textAlign:"center",
                        color:"#272727",
                        fontSize:20,
                    }
                    }>{this.state.primaryTitle}</div>

            <div className={styles["projects__items"]}>
                <div className={styles["projects__item"]}>
                    <img src={Project2} alt="" className={styles["image"]}/>
                    <div className={styles["projects__btns"]}>
                        <a href="https://bukrida.netlify.app" className={styles["projects__btn"]}>
                            <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>preview
                        </a>
                        <a href="https://github.com/favourite1975/bukrida" className={styles["projects__btn"]}>
                        <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>Github
                        </a>
                    </div>
                </div>
                <div className={styles["projects__item"]}>
                    <img src={Project3} alt="" className={styles["image"]}/>
                    <div className={styles["projects__btns"]}>
                        <a href="https://uplants.netlify.app" className={styles["projects__btn"]}>
                            <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>preview
                        </a>
                        <a href="https://github.com/favourite1975/phantom-netflix" className={styles["projects__btn"]}>
                        <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>Github
                        </a>
                    </div>
                </div>
                <div className={styles["projects__item"]}>
                    <img src={Project1} alt="" className={styles["image"]}/>
                    <div className={styles["projects__btns"]}>
                        <a href="https://phantom-netflix.netlify.app" className={styles["projects__btn"]}>
                            <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>preview
                        </a>
                        <a href="https://github.com/favourite1975/phantom-netflix" className={styles["projects__btn"]}>
                        <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>Github
                        </a>
                    </div>
                </div>
                <div className={styles["projects__item"]}>
                    <img src={Project1} alt="" className={styles["image"]}/>
                    <div className={styles["projects__btns"]}>
                        <a href="https://phantom-netflix.netlify.app" className={styles["projects__btn"]}>
                            <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>preview
                        </a>
                        <a href="https://github.com/favourite1975/phantom-netflix" className={styles["projects__btn"]}>
                        <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>Github
                        </a>
                    </div>
                </div>
                <div className={styles["projects__item"]}>
                    <img src={Project1} alt="" className={styles["image"]}/>
                    <div className={styles["projects__btns"]}>
                        <a href="https://phantom-netflix.netlify.app" className={styles["projects__btn"]}>
                            <FontAwesomeIcon icon={faEye}></FontAwesomeIcon>preview
                        </a>
                        <a href="https://github.com/favourite1975/phantom-netflix" className={styles["projects__btn"]}>
                        <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>Github
                        </a>
                    </div>
                </div>
           </div>
            </div>
        );
    }
}
 
export default Projects;

